<template>
  <div class="first-page" data-automation="firstPage">
    <div class="first-main">
      <my-header></my-header>

      <div class="first-center">
        <div class="first-login-kv"></div>
        <div class="first-view-box">
          <router-view class="first-view"></router-view>
        </div>
      </div>

      <div class="first-footer">
        <ux-button class="first-footer-link" text @click="gotoBeian">{{
          $t('HT.articleNo')
        }}</ux-button>
      </div>
    </div>
  </div>
</template>

<script>
import myHeader from '@c/myHeader/myHeader';
export default {
  components: {
    myHeader
  },
  methods: {
    gotoBeian() {
      window.open('https://beian.miit.gov.cn');
    }
  }
};
</script>

<style lang="scss" scoped>
.first-page {
  position: relative;
  width: 100%;
  overflow-x: auto;
  height: 100%;

  .my-header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .first-main {
    position: relative;
    min-width: 1280px;
    height: 100%;
    min-height: 800px;
    background: url('~@/assets/images/web/login-bg.jpg') no-repeat center center / cover;
  }

  .first-center {
    position: relative;
    width: 1280px;
    height: 100%;
    margin: 0 auto;
  }

  .first-login-kv {
    position: absolute;
    top: 50%;
    left: -100px;
    width: 830px;
    height: 480px;
    transform: translateY(-50%);
    background: url('~@/assets/images/web/login-kv.png') no-repeat center center / cover;
  }

  .first-view-box {
    position: absolute;
    top: 50%;
    right: 40px;
    transform: translateY(-50%);
    width: 416px;
    height: 580px;
    background: #fff;
    border-radius: 4px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -72px;
      display: block;
      width: 238px;
      height: 580px;
      background: url('~@/assets/images/web/login-box-shadow.png') no-repeat center center / cover;
    }
  }

  .first-view {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 2;
    background: #fff;
    box-shadow: 0px 2px 6px 0px $color-box-shadow;
    box-sizing: border-box;
  }

  .first-footer {
    position: absolute;
    left: 0;
    bottom: 50px;
    text-align: center;
    width: 100%;
  }
}
</style>
